<!-- 评论列表 -->
<template>
  <div class="container">
    <header class="header">
      <el-radio-group @change="radioChange" v-model="init.q.type">
        <el-radio label="0">客户发起的评价</el-radio>
        <el-radio label="1">我发起的评价</el-radio>
      </el-radio-group>
    </header>
    <div class="center">
      <div style="margin-bottom: 0.1rem" class="centerBox">
        <p>订单编号</p>
        <el-input style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="input" placeholder="订单编号"></el-input>
        <p>资源名称</p>
        <el-input style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="input" placeholder="资源名称"></el-input>
        <p>买家昵称</p>
        <el-input style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="input" placeholder="买家昵称"></el-input>
        <p>评级关键字</p>
        <el-input style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="input" placeholder="评级关键字
"></el-input>
        <p>评价类型</p>
        <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button style="color: #fff; background-color: #e69c37" size="small">搜索</el-button>
        <el-button size="small">重置</el-button>
      </div>
      <div class="centerBox">
        <p>回复情况</p>
        <el-select style="width: 1.5rem; margin-right: 0.1rem" size="small" v-model="value" placeholder="请选择">
          <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <p>评价时间</p>
        <el-date-picker style="margin-right: 0.1rem" size="small" v-model="value" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="晒图"></el-checkbox>
          <el-checkbox label="视频"></el-checkbox>
          <el-checkbox label="负面"></el-checkbox>
          <el-checkbox label="追评"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <footer class="footer">
      <el-radio-group v-model="radio2" size="small">
        <el-radio-button v-for="item in radio2List" :key="item" :label="item"></el-radio-button>
      </el-radio-group>
      <div class="right">
        <el-button size="small">手动回复</el-button>
        <el-button size="small">自动回复设置</el-button>
        <el-button size="small">催促供应商回复</el-button>
        <el-button size="small">导出</el-button>
      </div>
    </footer>
    <el-table border v-loading="loading" :data="tableData" :header-cell-style="{ color: '#000' }"
      @selection-change="handleSelectionChange" style="width: 100%">
      <el-table-column align="center" type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="200" prop="orderChildrenId" label="订单编号"> </el-table-column>
      <el-table-column align="center" prop="date" label="商品类型">
        <template slot-scope="scope">
          <span>{{ resourceType.find(n => n.code == scope.row.state).name1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="resourceName" label="商品信息"> </el-table-column>
      <el-table-column align="center" prop="date" label="评价时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | dateFormat }}</span>
          <span>{{ scope.row.overall }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" prop="date" label="评分">
        <template slot-scope="scope">
          总分：{{ scope.row.overall }}
          <span v-if="scope.row.state == 0">
            位置：{{ scope.row.position }}
            服务：{{ scope.row.service }}
            卫生：{{ scope.row.health }}
            设施：{{ scope.row.fac }}
          </span>
          <span v-if="scope.row.state == 4">
            口味：{{ scope.row.food }}
            服务：{{ scope.row.service }}
            环境：{{ scope.row.environment }}
          </span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="content" label="评价内容"> </el-table-column>
      <el-table-column align="center" prop="date" label="评价图片">
        <template slot-scope="scope">
          <el-image v-if="scope.row.photos.length > 0" style="width: 1rem;height: 1rem;" class="viewImgs"
            :src="scope.row.photos[0]" :preview-src-list="scope.row.photos">
          </el-image>
          <div v-else>
            暂无照片
          </div>
        </template>
      </el-table-column>
      <el-table-column width="170" align="center" prop="date" label="评价视频">
        <template slot-scope="scope">
          <span v-if="scope.row.videos.length == 0">暂无视频</span>
          <video v-else style="height: 1rem;" :src="scope.row.videos[0]" ref="video" controls alt width="100%"></video>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="replyName" label="回复人"> </el-table-column>
      <el-table-column align="center" prop="date" label="回复状态">
        <template slot-scope="scope">
          {{ scope.row.replyStatus == 1 ? '已回复' : '未回复' }}
        </template>
      </el-table-column>
    </el-table>
    <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
      @loadTable='loadTable'></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Api from "../../../../../components/Api";
import { resourceType } from '@/assets/utils/unit'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      init: {
        "page": 1,
        "q": {
          type: '0',
        },
        "size": 10
      },
      resourceType,
      pageSizes: [10, 20, 25, 30],
      loading: true,
      AllpagesNum: 0,
      tableData: [],
      checkList: [],
      input: "",
      value: "",
      radio2: "全部",
      radio2List: [
        "全部",
        "极力推荐",
        "超赞",
        "满意",
        "一般",
        "较差",
        "很差",
        "默认好评",
        "需供应商回复",
        "需自己回复",
        "很差/较差+待自己手动回复",
      ],
      radio: "客户发起的评价",
      options: [
        {
          value: "1",
          label: "默认好评",
        },
        {
          value: "2",
          label: "非默认好评",
        },
      ],
      options1: [
        {
          value: "1",
          label: "已手动回复",
        },
        {
          value: "2",
          label: "已自动回复",
        },
        {
          value: "3",
          label: "待回复",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSelectionChange() { },
    //获取订单列表
    getEvaluationList() {
      new Api("resource")
        .evaluationList(this.init)
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.records
            this.AllpagesNum = res.data.total
            console.log(this.tableData, '看看渲染的数据');
            this.loading = false
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    //单选框切换
    radioChange() {
      this.init.page = 1
      this.getEvaluationList()
    },
    loadTable(page, size) {
      this.init.size = size
      this.init.page = page
      this.loading = true
      this.getEvaluationList()
    },
  },
  created() { },
  mounted() {
    this.getEvaluationList()
  },
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    margin-bottom: 0.2rem;
  }

  .center {
    padding: 0.2rem;
    background-color: #f1f1f1;
    margin-bottom: 0.2rem;

    p {
      margin-right: 0.1rem;
    }

    .centerBox {
      display: flex;
      align-items: center;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .right {
      margin-left: auto;
    }
  }
}
</style>
